import * as types from '../types';
import { ICompanySettingsApi } from '../contracts';
import { HttpApi } from './HttpApi';

export class CompanySettingsHttpApi extends HttpApi implements ICompanySettingsApi {
  async getCompanySettings(): Promise<types.CompanySettings> {
    // One document per tenant: the tenant comes from the token, no id in the path.
    const response = await this.http.get<types.APIResponse<types.CompanySettings>>('/company-settings');
    return response.data.data;
  }

  async updateCompanySettings(data: types.UpdateCompanySettingsRequest): Promise<types.CompanySettings> {
    const response = await this.http.put<types.APIResponse<types.CompanySettings>>('/company-settings', data);
    return response.data.data;
  }
}
